import * as Icons from "lucide-react";
import { SPECIALTIES } from "@/lib/data";

export const SpecialtyStrip = () => (
  <section className="relative border-y border-[var(--border-subtle)] bg-[var(--bg-secondary)] py-6 overflow-hidden marquee-pause">
    <div className="flex w-max animate-marquee">
      {[...SPECIALTIES, ...SPECIALTIES, ...SPECIALTIES].map((s, i) => {
        const Icon = Icons[s.icon] || Icons.Sparkles;
        return (
          <div key={i} className="flex items-center gap-4 px-8">
            <span className="grid h-11 w-11 place-items-center rounded-xl border border-[var(--border-subtle)] text-[var(--accent-primary)]">
              <Icon size={20} />
            </span>
            <span className="font-heading text-base sm:text-lg font-medium text-[var(--text-secondary)] whitespace-nowrap">
              {s.label}
            </span>
            <span className="pl-4 text-[var(--accent-primary)]">✦</span>
          </div>
        );
      })}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-20 sm:w-32 bg-gradient-to-r from-[var(--bg-secondary)] to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-20 sm:w-32 bg-gradient-to-l from-[var(--bg-secondary)] to-transparent" />
  </section>
);
